import type { Target } from '@edgesub/converter';

export const TARGETS: Array<{ value: Target; label: string }> = [
  { value: 'mihomo', label: 'Mihomo' },
  { value: 'sing-box', label: 'sing-box' },
  { value: 'surge', label: 'Surge' },
  { value: 'loon', label: 'Loon' },
  { value: 'qx', label: 'Quantumult X' },
  { value: 'shadowrocket', label: 'Shadowrocket' },
  { value: 'uri', label: 'URI 列表' },
];

export const INTERVALS = [
  { value: 60, label: '1 小时' },
  { value: 180, label: '3 小时' },
  { value: 360, label: '6 小时' },
  { value: 720, label: '12 小时' },
  { value: 1440, label: '24 小时' },
] as const;

export function formatDate(value: string | null): string {
  if (!value) return '尚无记录';
  return new Intl.DateTimeFormat('zh-CN', {
    month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
  }).format(new Date(value));
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : '操作失败，请稍后重试';
}
